// Company screens must not fall back to customer addresses or location data.
export const COMPANY_FAMILIES = { civil: 'نیروهای توسعه', last_mile: 'نصاب‌های لست‌مایل' };
const KINDS = {
  new_install: 'نصب جدید', repair: 'رفع خرابی', relocation: 'جابجایی', modem_swap: 'تعویض مودم',
  segment: 'قطعه مسیر', manhole: 'منهول', fat: 'نصب FAT', odc: 'کابینت ODC',
  closure: 'مفصل', restoration: 'مرمت',
};
export const companyJobKind = (job) => job.job_kind ? KINDS[job.job_kind] || job.job_kind : null;
export const companyFamily = (job) => COMPANY_FAMILIES[job.work_family || 'last_mile'];
